import authenticated from '../http-clients/authenticated'
import componentsApi from '@/api/components'
import topicsApi from '@/api/topics'

export default {
  snapshot({ tenantID }) {
    return authenticated({
      url: `/tenants/${tenantID}/reports/knowledgechecks/snapshot`,
      method: 'get'
    })
  },
  async completed(params){
    let url = `/tenants/${params.tenantId}/reports/knowledgechecks/responses/completed?`

    if (typeof(params.module) !== 'undefined' && params.module !== null) {
      url = `${url}&module=${params.module}`
    }
    if (typeof(params.component) !== 'undefined' && params.component !== null) {
      url = `${url}&component=${params.component}`
    }
    if (typeof(params.topic) !== 'undefined' && params.topic !== null) {
      url = `${url}&topic=${params.topic}`
    }
    if (typeof(params.user) !== 'undefined' && params.user !== null) {
      url = `${url}&user=${params.user}`
    }

    if (typeof(params.paginate) !== 'undefined' && params.paginate !== null) {
      url = `${url}&paginate=${params.paginate}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }

    return await authenticated({
      url,
      method: 'get'
    })
  },
  async getComponentOptions({tenantId, moduleId}){
    let names = []

    if(moduleId){
      const response = await componentsApi.index({tenantID: tenantId, moduleID: moduleId})
      names = response.data.data.map((c) => {
        return {
          text: c.name,
          value: c.id
        }
      })
    }

    names.unshift({text: 'All Components', value: null})
    return names
  },
  async getTopicOptions({tenantId, componentId}){
    let names = []

    if(componentId){
      const response = await topicsApi.index({tenantID: tenantId, componentID: componentId})
      names = response.data.data.map((c) => {
        return {
          text: c.name,
          value: c.id
        }
      })
    }

    names.unshift({text: 'All Topics', value: null})
    return names
  },
  async getResponseDetail({tenantId, responseId}){

    const url = `/tenants/${tenantId}/reports/knowledgechecks/responses/${responseId}`

    return await authenticated({
      url,
      method: 'get'
    })
  }

}



// WEBPACK FOOTER //
// ./src/api/knowledgechecks/reports.js